module.exports = __webpack_public_path__ + "media/images/working_from_anywhere-cffebe73f701da0dc2b9b64d27e1fd90.png";